import { configureStore } from '@reduxjs/toolkit'
import loginReducer from './components/slices/LoginSlice'

export default configureStore({
  reducer: {
    login: loginReducer,
  },
})
